import { Component } from "vue-property-decorator";
import Template from "./template.vue";
import FormsMixin from "@/mixins/FormsMixin";
import { Action } from 'vuex-class';
import Header from "@/components/Header/components";
import { CLIENTES } from "@/store/modules/SeleccionCliente/types";
import { ARTICULO, CESTA } from "@/store/modules/ventas/types";
import { CONTACTO, DIRENT, PedidoERP } from "@/store/modules/FinalizarPedido/types";

@Component({
  mixins: [Template],
  components: {
    Header,
  },
})
export default class FinalizarPedido extends FormsMixin {
  @Action("servirPedido", { namespace: "FinalizarPedido" }) servirPedido!: Function;
  @Action("listarDirecciones", { namespace: "FinalizarPedido" }) listaDirecciones!: Function;
  @Action("obtenerContacto", { namespace: "FinalizarPedido" }) obtenerContacto!: Function;
  @Action("checkStock", { namespace: "ventas" }) checkStock!: Function;

  public DialogFinalizaPedido = false;
  public listadoDirecciones: Array<DIRENT> = [];
  public contacto: CONTACTO = {
    TEL: "",
    NOMBRE: ""
  };
  public listadoLineas: Array<ARTICULO> = [];
  public cesta: Array<CESTA> = [];
  public cliente: CLIENTES = {
    CODCLI: "",
    NOMCLI: "",
    AT_APP: "",
    AT_PASSWORD: "",
    CODREP: "",
    E_MAIL: "",
    NIFCLI: ""
  };
  public direccionSeleccionada: DIRENT = {
    IDDIRENT: 0,
    DIR: "",
    POBDIR: "",
    DTO: "",
    CONTACTO: "",
    TELENT1: ""
  };

  public direccionCreada: DIRENT = {
    IDDIRENT: 0,
    DIR: "",
    POBDIR: "",
    DTO: "",
    CONTACTO: "",
    TELENT1: ""
  };
  public pestaña: any = null;
  public pestañaActual = "S";
  public OBSERVACIONES = "";

  async mounted() {
    this.$root.$emit("loading", true);
    this.cliente = JSON.parse(localStorage.getItem('CliePedido') || '{}');
    this.listadoDirecciones = await this.listaDirecciones({ codcli: this.cliente.CODCLI });
    this.contacto = await this.obtenerContacto({ codcli: this.cliente.CODCLI })
    console.log(this.listadoDirecciones);
    
    if (this.listadoDirecciones.length > 0 ) this.DireccionSelCambiada(this.listadoDirecciones[0]);
    this.$root.$emit("loading", false);
    this.$root.$on("devolverCesta", (cesta: Array<CESTA>) => { this.cesta = cesta })
    this.$root.$emit("solicitarCesta");
    this.pestaña = 1;
    window.scrollTo(0, 0);
  }

  DireccionMontada(_dirent: DIRENT) {
    return _dirent.DIR + ", (" + _dirent.DTO + "). " + _dirent.POBDIR
  }

  DireccionSelCambiada(_dirent: DIRENT) {    
    this.direccionSeleccionada = _dirent
    this.contacto.NOMBRE = this.direccionSeleccionada.CONTACTO;
    this.contacto.TEL = this.direccionSeleccionada.TELENT1;
  }

  HayDirecciones() {
    return (this.listadoDirecciones.length > 0)
  }

  async VerDialogFinalizar() {
    this.DialogFinalizaPedido = true;
  }

  Pestaña(actual: string) {
    this.pestañaActual = actual;
  }

  OcultaDialogFinalizar() {
    this.DialogFinalizaPedido = false;
  }

  public creandoPedido = false;
  async FinalizarPedido() {
    let direccion: DIRENT;
    
    if (this.pestañaActual == "S") {
      direccion = this.direccionSeleccionada;
      
    } else {
      direccion = this.direccionCreada;
    }   
    

    const pedido: PedidoERP = {
      FECHA: new Date().toLocaleString(),
      CESTA: this.cesta,
      CLIENTE: this.cliente,
      CONTACTO: this.contacto,
      DIRECCION: direccion,
      OBSERVACIONES: this.OBSERVACIONES
    }

    this.$root.$emit("loading", true);
    this.creandoPedido = true;
    const pedidoCorrecto = await this.servirPedido(pedido);
    this.creandoPedido = false;
    this.$root.$emit("loading", false);
    

    if(pedidoCorrecto){
      localStorage.removeItem("cesta");
      this.$toast.success("Pedido Generado Correctamente.");
      this.$router.push({ name: "venta" });
      this.DialogFinalizaPedido = false;
    } else {
      this.$toast.error("No se ha podido generar el Pedido correctamente.");
    }
    
  }




}
